export default class EvidenceInfo {
    constructor(otherEvidenceFound, totalNumberOfEvidence, comments, evidenceinfopages) {
        this.otherEvidenceFound = otherEvidenceFound;
        this.totalNumberOfEvidence = totalNumberOfEvidence;
        this.comments = comments;
        this.evidenceinfopages = evidenceinfopages;
    }
}